// extracted by mini-css-extract-plugin
export default {"root":"root___wVgn6","title":"title___wSmqj","subj":"subj___QBVsn","textarea":"textarea___fGXAS","buttons":"buttons___BphTr","err":"err___b5Khl"};